import { ContextCancelation, type Plugin } from '@segment/analytics-next'

import {
  DEDUPE_WINDOW_MS,
  evaluateDuplicateTrack,
  recordAllowedTrack,
} from './dedupe'

const reportBlockedDuplicate = ({
  eventName,
  deltaMs,
}: {
  eventName: string
  deltaMs: number
}) => {
  console.warn(
    `[analytics] duplicate track blocked: "${eventName}" (${deltaMs}ms since last identical send, window ${DEDUPE_WINDOW_MS}ms)`
  )
}

export const createDuplicateGuardPlugin = (): Plugin => ({
  name: 'Segment Duplicate Guard (dev)',
  type: 'before',
  version: '1.0.0',
  isLoaded: () => true,
  load: () => Promise.resolve(),
  track: ctx => {
    const eventName = ctx.event.event

    if (!eventName || ctx.event.type !== 'track') {
      return ctx
    }

    const properties = (ctx.event.properties ?? {}) as Record<string, unknown>
    const now = Date.now()
    const decision = evaluateDuplicateTrack(eventName, properties, now)

    if (decision.block) {
      reportBlockedDuplicate({
        eventName,
        deltaMs: decision.deltaMs,
      })

      ctx.cancel(
        new ContextCancelation({
          reason: 'duplicate-track-blocked',
          retry: false,
        })
      )

      return ctx
    }

    recordAllowedTrack(decision.fingerprint, now)

    return ctx
  },
})
